import { createLogic } from 'redux-logic';
import { formsLoadExisting, formsLoaded, formSelect } from '../actions';
import { apiGet } from '../api';
import find from 'lodash/find';

const loadExistingForms = createLogic({
    type: formsLoadExisting,
    latest: true,
    async process({ getState }, dispatch, done) {
        const authContext = getState().authentication;
        const token = await authContext.getAccessToken(authContext.authorizationScopes.forms);

        apiGet('/forms', token)
            .then((result) => {
                dispatch(formsLoaded(result.data));
            })
            .catch(() => {})
            .finally(done);
    },
});

const selectForm = createLogic({
    type: formSelect,
    latest: true,
    transform({ getState, action }, next) {
        const formId = action.payload;
        const { forms } = getState();
        const form = find(forms.existing, (form) => form.id.toString() === formId) || {};

        next({
            ...action,
            payload: form,
        });
    },
});

export default [loadExistingForms, selectForm];
